import Vue from 'vue'
import loading from './loading.vue'

let loadingModel = null;
let LoadingConstructor = Vue.extend(loading)

let init = () => {
    loadingModel = new LoadingConstructor().$mount()
    console.log(loadingModel.$el)
    document.body.appendChild(loadingModel.$el)
}

let caller = () => {
    if (!loadingModel) {
        init()
    }
    return loadingModel;
}
export default {
    // 返回 install 函数 用于 Vue.use 注册
    install(vue) {
        vue.prototype.$loading = caller()
    }
}


// WEBPACK FOOTER //
// ./src/components/loading/loading.js